import { AdditionalExposuresSummaryDescription } from '../../components/ToxicExposureSummary';
import {
  additionalExposuresSummaryPageTitle,
  titleWithSubtitle,
} from '../../content/toxicExposure';

export const uiSchema = {
  'ui:title': titleWithSubtitle(additionalExposuresSummaryPageTitle, 'Summary'),
  'ui:description': AdditionalExposuresSummaryDescription,
};

export const schema = {
  type: 'object',
  properties: {},
};
